export type ConsentType = 'tos_privacy' | 'ai_cv'

export interface ConsentInput {
  type: ConsentType
  policy_version: string
  accepted: boolean
}

export interface ConsentItem {
  type: ConsentType
  policy_version: string
  accepted_at: string
  is_active: boolean
}

export interface ConsentStatus {
  requires_re_consent: boolean
  consents: ConsentItem[]
}

export const CURRENT_POLICY_VERSIONS: Record<ConsentType, string> = {
  tos_privacy: '1.0',
  ai_cv: '1.0',
}
